// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_y09","cls2":"ImpactHubModal-cls2_C1D ImpactHubModal-cls1_y09"};